const testimonialData = [
  {
    name: 'Marcus Thompson',
    role: 'Sneaker Collector',
    content: 'The Hipobuy Spreadsheet completely changed how I discover new releases. Instead of scrolling through dozens of sites, I have everything organized in one place. The category breakdown is incredibly intuitive.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20stylish%20man%20in%20casual%20blazer%20against%20warm%20cream%20studio%20backdrop%2C%20friendly%20confident%20expression%2C%20soft%20natural%20lighting%2C%20modern%20editorial%20headshot%2C%20neutral%20earth%20tones%2C%20clean%20sophisticated%20portrait%20photography&width=96&height=96&seq=avatar-v2-marcus&orientation=squarish',
  },
  {
    name: 'Elena Rodriguez',
    role: 'Fashion Blogger',
    content: 'As someone who writes about streetwear daily, having access to organized spreadsheet databases saves me hours of research. The Hipobuy Spreadsheet resource has become an essential part of my workflow.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20woman%20with%20warm%20smile%20against%20cream%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20modern%20editorial%20headshot%2C%20friendly%20approachable%20expression%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20photography&width=96&height=96&seq=avatar-v2-elena&orientation=squarish',
  },
  {
    name: 'James Chen',
    role: 'Online Shopping Enthusiast',
    content: 'I used to waste so much time jumping between different platforms trying to compare products. The Hipobuy Spreadsheet hub puts everything at my fingertips — it is genuinely the best shopping research tool I have found.',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20man%20with%20relaxed%20confident%20expression%20against%20cream%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20modern%20editorial%20headshot%2C%20casual%20refined%20style%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20portrait%20photography&width=96&height=96&seq=avatar-v2-james&orientation=squarish',
  },
];

export default function TrustSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-accent-500 mb-3"></span>
          <p className="text-xs font-label font-semibold uppercase tracking-wider text-accent-500 mb-3">
            Trusted by Shoppers
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            What the Community Says About<br />
            Hipobuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm md:text-base font-body text-foreground-600 max-w-xl mx-auto">
            Real experiences from real users who rely on organized spreadsheet resources for smarter shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {testimonialData.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-lg p-6 md:p-7 flex flex-col">
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm md:text-base font-body text-foreground-700 leading-relaxed flex-1 mb-5">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs font-body text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-background-50 rounded-lg p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10,000+</p>
              <p className="text-xs md:text-sm font-body text-foreground-600 mt-1">Product Resources</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">100+</p>
              <p className="text-xs md:text-sm font-body text-foreground-600 mt-1">SEO Guides</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">14</p>
              <p className="text-xs md:text-sm font-body text-foreground-600 mt-1">Spreadsheet Categories</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">Weekly</p>
              <p className="text-xs md:text-sm font-body text-foreground-600 mt-1">Updated Resources</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}